import { createContext, useContext } from 'react'
import type { FilterFieldsFormContextValue } from './FilterFieldsFormContext.types'

const defaultContextValue: FilterFieldsFormContextValue = {
  groupedFieldValues: {},
  composition: '1',
  initialGroupedFieldValues: {},
  sections: [],
  handleChange: () => undefined,
  handleComposition: () => undefined,
  handleClear: () => undefined,
  executeFilter: () => undefined
}

export const FilterFieldsFormContext =
  createContext<FilterFieldsFormContextValue>(defaultContextValue)

export const useFilterFieldsForm = () => {
  return useContext(FilterFieldsFormContext)
}
